/* RegularSection.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _20 = "._k48p1nn1{font-weight:400}";
const _19 = "._19pku2gc{margin-top:var(--ds-space-100,8px)}";
const _18 = "._y3gn1h6o{text-align:center}";
const _17 = "._k48p1fw0{font-weight:700}";
const _16 = "._2lx21bp4{flex-direction:column}";
const _15 = "._1bah1h6o{justify-content:center}";
const _14 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _13 = "._19pk1ejb{margin-top:var(--ds-space-300,24px)}";
const _12 = "._i0dl1n8h{flex-basis:70%}";
const _11 = "._1o9zkb7n{flex-shrink:1}";
const _10 = "._16jlkb7n{flex-grow:1}";
const _9 = "@media (min-width:64rem){._isu4xy5q{margin-bottom:var(--ds-space-400,2pc)}}";
const _8 = "@media (min-width:48rem) and (max-width:63.99rem){._1b7e1ejb{margin-bottom:var(--ds-space-300,24px)}}";
const _7 = "._otyrpxbi{margin-bottom:var(--ds-space-200,1pc)}";
const _6 = "._4cvr1h6o{align-items:center}";
const _5 = "._1bah1yb4{justify-content:space-between}";
const _4 = "._1e0c1txw{display:flex}";
const _3 = "._zulppxbi{gap:var(--ds-space-200,1pc)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Hide, media, Show } from '@atlaskit/primitives/responsive';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { BodyLarge, H3, LinkWithIcon } from '@atlassian/mpac-primitives';
import { useHistory } from '@atlassian/mpac-ui';
import React from 'react';
import { useHomepageAnalytics } from '../../hooks/useHomepageAnalytics';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _2 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _ = "._19pk1b66{margin-top:var(--ds-space-050,4px)}";
export const Description = forwardRef((_ref, __cmplr) => {
  let {
      as: C = BodyLarge,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pk1b66 _syaz1gjq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Description.displayName = 'Description';
}
const DescriptionStyle = null;
const H3Style = null;
const SectionHeaderStyle = null;
export const SectionHeader = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_3, _4, _5, _6, _7, _8, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulppxbi _1e0c1txw _1bah1yb4 _4cvr1h6o _otyrpxbi _1b7e1ejb _isu4xy5q", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SectionHeader.displayName = 'SectionHeader';
}
const HeaderDetails = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_10, _11, _12]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_16jlkb7n _1o9zkb7n _i0dl1n8h", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  HeaderDetails.displayName = 'HeaderDetails';
}
const LinkWrapper = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_13]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pk1ejb", __cmplp.className])
    }))]
  });
});

// eslint-disable-next-line max-lines-per-function
if (process.env.NODE_ENV !== 'production') {
  LinkWrapper.displayName = 'LinkWrapper';
}
export const RegularSection = _ref5 => {
  let {
    title,
    description,
    children,
    navigationUrl
  } = _ref5;
  const history = useHistory();
  const {
    tractExploreMoreAppClick
  } = useHomepageAnalytics();
  const navigationLinkClickHandler = event => {
    event.preventDefault();
    if (navigationUrl) tractExploreMoreAppClick(title, navigationUrl);
    history === null || history === void 0 ? void 0 : history.push(navigationUrl);
  };
  const ariaLabel = title.toLowerCase().includes('apps') ? "Explore more ".concat(title) : "Explore more ".concat(title, " apps");
  const {
    enableMpacWebCoherence
  } = useStatsig();
  if (enableMpacWebCoherence()) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_14, _4, _15, _16, _6, _8]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_zulpu2gc _1e0c1txw _1bah1h6o _2lx21bp4 _4cvr1h6o _1b7e1ejb"]),
          children: [/*#__PURE__*/_jsxs(HeaderDetails, {
            children: [/*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_17, _18]
              }), /*#__PURE__*/_jsx(H3, {
                as: "h2",
                className: ax(["_k48p1fw0 _y3gn1h6o"]),
                children: title
              })]
            }), description && /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_19, _20, _18]
              }), /*#__PURE__*/_jsx(BodyLarge, {
                "data-testid": "section-description",
                className: ax(["_19pku2gc _k48p1nn1 _y3gn1h6o"]),
                children: description
              })]
            })]
          }), navigationUrl && /*#__PURE__*/_jsx(Show, {
            above: "sm",
            children: /*#__PURE__*/_jsx(LinkWithIcon, {
              size: "medium",
              type: "internal",
              onClick: event => navigationLinkClickHandler(event),
              href: navigationUrl,
              "aria-label": ariaLabel,
              children: "Explore more apps"
            })
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        children: children
      }), navigationUrl && /*#__PURE__*/_jsx(Hide, {
        above: "sm",
        children: /*#__PURE__*/_jsx(LinkWrapper, {
          children: /*#__PURE__*/_jsx(LinkWithIcon, {
            size: "medium",
            type: "internal",
            onClick: event => navigationLinkClickHandler(event),
            href: navigationUrl,
            "aria-label": ariaLabel,
            children: "Explore more apps"
          })
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(SectionHeader, {
      children: [/*#__PURE__*/_jsxs(HeaderDetails, {
        children: [/*#__PURE__*/_jsx(H3, {
          as: "h2",
          children: title
        }), description && /*#__PURE__*/_jsx(Description, {
          "data-testid": "section-description",
          children: description
        })]
      }), navigationUrl && /*#__PURE__*/_jsx(Show, {
        above: "sm",
        children: /*#__PURE__*/_jsx(LinkWithIcon, {
          size: "medium",
          type: "internal",
          onClick: event => navigationLinkClickHandler(event),
          href: navigationUrl,
          "aria-label": ariaLabel,
          children: "Explore more apps"
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      children: children
    }), navigationUrl && /*#__PURE__*/_jsx(Hide, {
      above: "sm",
      children: /*#__PURE__*/_jsx(LinkWrapper, {
        children: /*#__PURE__*/_jsx(LinkWithIcon, {
          size: "medium",
          type: "internal",
          onClick: event => navigationLinkClickHandler(event),
          href: navigationUrl,
          "aria-label": ariaLabel,
          children: "Explore more apps"
        })
      })
    })]
  });
};